export const GET_ORGANISATION_BUILDING_BY_NAME = (name: string) => `query {
  buildingByOrganisationName(name: "${name}") {
    ... on ErrorListOutput {
      errors {
        type
        message
      }
    }
    ... on BuildingsOutput {
      buildings {
        fullAddress {
          addressNumber
          country
          municipality
          neighborhood
          postalCode
          region
          street
          subAddressNumber
          label
        }
        id
        name
      }
    }
  }
}`;
